/* ============================================================
   Hero Slider — assets/hero-slider.js
   ============================================================ */

class HeroSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.m-hs__slide'));
    this.dots   = Array.from(el.querySelectorAll('.m-hs__dot'));
    this.prevBtn = el.querySelector('.m-hs__arrow--prev');
    this.nextBtn = el.querySelector('.m-hs__arrow--next');

    this.current  = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed    = parseInt(el.dataset.speed, 10) || 5000;
    this.timer    = null;
    this.paused   = false;

    // Store instance on element for design-mode access
    el._heroSlider = this;

    if (this.slides.length <= 1) return;

    this._bindEvents();
    if (this.autoplay) this._startAutoplay();
  }

  // ── Public API ──────────────────────────────────────────────

  goTo(index) {
    const prev = this.current;
    this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;

    if (prev === this.current) return;

    this.slides[prev].classList.remove('is-active');
    this.slides[this.current].classList.add('is-active');

    if (this.dots[prev])          this.dots[prev].classList.remove('is-active');
    if (this.dots[this.current])  this.dots[this.current].classList.add('is-active');
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  // ── Autoplay ─────────────────────────────────────────────────

  _startAutoplay() {
    this._stopAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  _stopAutoplay() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  // ── Events ───────────────────────────────────────────────────

  _bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this._stopAutoplay();
        this.prev();
        if (this.autoplay && !this.paused) this._startAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this._stopAutoplay();
        this.next();
        if (this.autoplay && !this.paused) this._startAutoplay();
      });
    }

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this._stopAutoplay();
        this.goTo(i);
        if (this.autoplay && !this.paused) this._startAutoplay();
      });
    });

    // Pause autoplay while hovering
    this.el.addEventListener('mouseenter', () => {
      this.paused = true;
      this._stopAutoplay();
    });
    this.el.addEventListener('mouseleave', () => {
      this.paused = false;
      if (this.autoplay) this._startAutoplay();
    });

    // Touch / swipe support
    let startX = 0;
    let startY = 0;
    this.el.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    this.el.addEventListener('touchend', e => {
      const dx = startX - e.changedTouches[0].clientX;
      const dy = Math.abs(startY - e.changedTouches[0].clientY);
      // Only swipe horizontally (ignore vertical scrolls)
      if (Math.abs(dx) > 50 && dy < 40) {
        this._stopAutoplay();
        dx > 0 ? this.next() : this.prev();
        if (this.autoplay && !this.paused) this._startAutoplay();
      }
    }, { passive: true });
  }
}

// ── Init ──────────────────────────────────────────────────────

function initHeroSliders(root) {
  (root || document).querySelectorAll('.m-hero-slider').forEach(el => {
    if (!el._heroSlider) new HeroSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initHeroSliders());

// Shopify theme editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    initHeroSliders(e.target);
  });

  document.addEventListener('shopify:section:unload', e => {
    const el = e.target.querySelector('.m-hero-slider');
    if (el && el._heroSlider) {
      el._heroSlider._stopAutoplay();
      el._heroSlider = null;
    }
  });

  // When a slide block is selected in the editor, jump to that slide
  document.addEventListener('shopify:block:select', e => {
    const slider = e.target.closest('.m-hero-slider');
    if (!slider || !slider._heroSlider) return;
    const instance = slider._heroSlider;
    const idx = instance.slides.indexOf(e.target);
    if (idx >= 0) {
      instance._stopAutoplay();
      instance.goTo(idx);
    }
  });

  // Resume autoplay when block is deselected
  document.addEventListener('shopify:block:deselect', e => {
    const slider = e.target.closest('.m-hero-slider');
    if (!slider || !slider._heroSlider) return;
    const instance = slider._heroSlider;
    if (instance.autoplay && !instance.paused) instance._startAutoplay();
  });
}
